import { SyntheticEvent, useState } from 'react'

import Dialog from '../shared/Dialog'

interface GuideDialogLinkProps {
  html: any
  title: string
  url: string
}

const GuideDialogLink = ({ html, title, url }: GuideDialogLinkProps) => {
  const [opened, setOpened] = useState(false)

  return (
    <>
      <a href={url} onClick={toggleDialog} aria-haspopup='dialog'>
        <span className='c-img-like c-img-like--2/3'>{title}</span>
      </a>
      <Dialog
        className='right-modal'
        onCancel={toggleDialog}
        opened={opened}
        title={title}
      >
        <div className='u-font-sm' dangerouslySetInnerHTML={{ __html: html }} />
      </Dialog>
    </>
  )

  function toggleDialog(event: SyntheticEvent) {
    event.preventDefault()
    setOpened(!opened)
  }
}

export default GuideDialogLink
